import { QueryKey } from 'constants/query-key';
import { EventPlace } from 'helpers/analytics';
import type { ProductOnboardingStep } from 'interfaces/entities/product-onboarding';
import type { ICompanyContactInfo, IContactInfoApiResponse } from 'services/api/lookup/interfaces';
import { trackEvent } from 'services/event-tracking';
import { getQueryClient } from 'services/query-client/client';

import { type OnboardingEventStepCompletedType } from './constants';

interface ISuccessOnboardingStepPayload {
  step: ProductOnboardingStep;
  eventName: string;
  eventType: OnboardingEventStepCompletedType;
}

export const handleOnboardingStepSuccess = async ({
  step,
  eventName,
  eventType,
}: ISuccessOnboardingStepPayload): Promise<void> => {
  const queryClient = getQueryClient();
  await queryClient.refetchQueries([QueryKey.OnboardingProgress]);

  const onboardingProgress = queryClient.getQueryData([QueryKey.OnboardingProgress]);

  const completedStepsCount = onboardingProgress
    ? Object.values(onboardingProgress).filter(Boolean).length - 1
    : undefined;

  trackEvent(eventName, EventPlace.OnboardingList, {
    stepName: step,
    type: eventType,
    order: completedStepsCount,
  });
};

const isPersonContactInfo = (response): response is IContactInfoApiResponse => 'person' in response;
export const mapApiResponseToDto = (
  response: IContactInfoApiResponse | ICompanyContactInfo,
): IContactInfoApiResponse => {
  if (isPersonContactInfo(response)) {
    return {
      person: response.person,
      company: response.company,
    };
  }

  return {
    person: null,
    company: response,
  };
};
